import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StorageContainersEnum } from '../enums/blob-storage.enum';

@Injectable({
  providedIn: 'root',
})
export class BlobStorageService {
  constructor(private http: HttpClient) { }

  uploadFile(file: File, storageContainerName: string): Observable<{ blobStorageId: string }> {
    const storageContainer: string = storageContainerName ?? StorageContainersEnum.ATTACHMENT;

    const params = new HttpParams().set('storageContainer', storageContainer);

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<{ blobStorageId: string }>('/v1/blob-storage/upload', formData, { params });
  }

  downloadFile(blobStorageId: string): Observable<Blob> {
    const params = new HttpParams().set('blobStorageId', blobStorageId);

    return this.http.get('/v1/blob-storage/download', {
      params,
      responseType: 'blob',
    });
  }

  downloadAllAttachments(parentEntityType: string, parentEntityId: number): Observable<Blob> {
    let params = new HttpParams();
    params = params.set('parentEntityType', parentEntityType);
    params = params.set('parentEntityId', parentEntityId);

    return this.http.get('/v1/blob-storage/download-all-attachments', {
      params,
      responseType: 'blob',
    });
  }

  deleteFile(blobStorageId: string): Observable<void> {
    return this.http.delete<void>(`/v1/blob-storage/${blobStorageId}`);
  }
}
